/**
 * Csv Schema of Cargo
 * @author Thacryba
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {Cargo} from '@/model/resource/Cargo'

export class CsvCargoSchema extends Schema {
  readonly name = 'CsvCargo'

  readonly fieldSet: FieldSet<Cargo> = {
    idCargoPk: schema => schema.model.idCargoPk,
    document: schema => schema.model.document,
    emissionDate: schema => Helper.datetime(schema.model.emissionDate),
    deliveryDate: schema => Helper.datetime(schema.model.deliveryDate),
    systemDeliveryDate: schema =>
      Helper.datetime(schema.model.systemDeliveryDate),
    creationDate: schema => Helper.datetime(schema.model.creationDate),
    expectedDate: schema => Helper.datetime(schema.model.expectedDate),
    active: schema => Helper.bool(schema.model.active),
    note: schema => schema.model.note,
    idCreatorSystemFk: schema => schema.model.creatorSystem?.$id ?? null,
    idFinisherSystemFk: schema => schema.model.finisherSystem?.$id ?? null,
    idCargoStatusFk: schema => schema.model.cargoStatus?.$id ?? null,
    idTransporterFk: schema => schema.model.transporter?.$id ?? null,
    idShipperFk: schema => schema.model.shipper?.$id ?? null,
    idPanelUserCreatorFk: schema => schema.model.creator?.$id ?? null,
    idDriverFk: schema => schema.model.driver?.$id ?? null,
    idReceptorFk: schema => schema.model.receptor?.$id ?? null,
    dte: schema => schema.model.dte,
    idAddressFk: schema => schema.model.address?.$id ?? null,
    idOccurrenceFk: schema => schema.model.occurrence?.$id ?? null,
    idDocumentPhotoFk: schema => schema.model.idDocumentPhotoFk,
    returned: schema => Helper.bool(schema.model.returned),
    idVisualizationModeFk: schema =>
      schema.model.visualizationMode?.$id ?? null,
  }
}
